import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, ButtonComponent],
})
export class AlertComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA)
        public data: {
            icon: string;
            connotation: string;
            title: string;
            description: string;
            dismissible: boolean;
            dismissButtonLabel?: string; // If buttonLabel is provided, it will be used instead of the default dismiss button
            width?: string;
        },
        public snackBarRef: MatSnackBarRef<AlertComponent>,
    ) {}
}
